import { FilterBase } from './filter-base';

export class ListViewModelBase{

    public isOpening: boolean;
    public isLoading: boolean;
    public totalCount: number;    
    public header: string;

    public filter: FilterBase;
}